import { useRouter } from 'next/router';
import { usePageLocale } from 'src/contexts';
import { prependLocale, prependStagingHash } from 'src/lib/utils';

// Mirrors the fallback branch of Inputs/Link/Link.tsx: when next.js i18n is
// active (router.locale present) it already localizes, so leave the href
// untouched; otherwise prepend the page locale and the staging basePath. The
// WEB3 button variants pass Link as an MUI slot root, which forwards extra
// props and prevents Link's own fallback from ever running, so they localize
// the href themselves via this hook.
export const useLocalizedHref = (href?: string): string | undefined => {
  const router = useRouter();
  const userLocale = usePageLocale();

  if (!href || router?.locale) return href;

  return prependStagingHash(
    prependLocale({ locale: userLocale, href }),
    router?.basePath || '',
  );
};
